import { useRef, useState, useContext, useEffect } from 'react';
import { Menu, Avatar, Box, Typography, Divider, useTheme, Switch, FormControlLabel, Chip, Collapse, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import ButtonBasic from '../buttons/ButtonBasic';
import LogoutIcon from '@mui/icons-material/Logout';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import WifiIcon from '@mui/icons-material/Wifi';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { ColorModeContext } from '../../themes/themes';
import { SocketContext } from '../../context/SocketContext';
const MenuUsuarioNav = ({
    onLogout
}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const colorMode = useContext(ColorModeContext);
    const { sockets, online } = useContext(SocketContext);

    const ref = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [showSockets, setShowSockets] = useState(false);
    const [socketEvents, setSocketEvents] = useState([]);
    const user = useSelector((state) => state.auth.currentUser);

    const [currentRoom, setCurrentRoom] = useState(null);

    useEffect(() => {
        if (isOpen && sockets) {
            const callbacks = sockets._callbacks || {};
            const events = Object.keys(callbacks)
                .map(e => e.replace(/^\$/, ''))
                .filter(e => !['connect', 'disconnect', 'connecting', 'connect_error', 'reconnect'].includes(e));
            setSocketEvents(events);
            const room = localStorage.getItem('ticketId');
            setCurrentRoom(room || null);
        }
    }, [isOpen, sockets]);
    return (
        <>
        <Avatar
            ref={ref}
            onClick={() => setIsOpen(true)}
            sx={{boxShadow:3,border:1,borderColor: isDarkMode ? '#3d4a62' : '#9d9ea4','&:hover': {cursor: 'pointer'}}}
            src={user?.foto_p}
        />

        <Menu
            open={isOpen}
            anchorEl={ref.current}
            onClose={() => setIsOpen(false)}
            PaperProps={{
                sx: {
                    width: 270,
                    background: isDarkMode ? '#1F2A40 !important' : '#fff !important',
                    boxShadow: 8,
                    border: isDarkMode ? '1px solid #3d4a62' : 'none'
                }
            }}
        >
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column',mt:1}}>
                <Avatar
                    src={user?.foto_p}
                    sx={{width:90, height:90,boxShadow:6}}
                />
                <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',mt:2,fontWeight: 'bold'}} variant='h5'>{user?.nombre_p}</Typography>
                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',mt:1}}>{`${user?.puesto_p || ''} - ${user?.razonSocial_p || ''}`}</Typography>
                <Typography sx={{color: isDarkMode ? '#b0bec5' : '#15294b',mt: 1}}>{user?.email_p}</Typography>
            </Box>
            <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray',mb:1}} />
            
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2}}>
                <Box 
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        padding: '8px 16px',
                        borderRadius: 3,
                        background: isDarkMode ? '#2d3a52' : '#f5f5f5',
                        transition: 'all 0.3s ease'
                    }}
                >
                    <LightModeIcon sx={{ color: !isDarkMode ? '#f59e0b' : '#b0bec5', fontSize: 20 }} />
                    <Switch
                        checked={isDarkMode}
                        onChange={colorMode.toggleColorMode}
                        sx={{
                            '& .MuiSwitch-switchBase': {
                                color: isDarkMode ? '#b0bec5' : '#f59e0b',
                                '&:hover': {
                                    backgroundColor: isDarkMode ? 'rgba(100, 181, 246, 0.08)' : 'rgba(245, 158, 11, 0.08)',
                                },
                            },
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#64B5F6',
                                '&:hover': {
                                    backgroundColor: 'rgba(100, 181, 246, 0.08)',
                                },
                            },
                            '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                                backgroundColor: isDarkMode ? '#3d4a62' : '#cbd5e0',
                                opacity: 1,
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: isDarkMode ? '#1F2A40' : '#4a5568',
                                opacity: 1,
                            },
                        }}
                    />
                    <DarkModeIcon sx={{ color: isDarkMode ? '#64B5F6' : '#b0bec5', fontSize: 20 }} />
                </Box>
            </Box>
            
            <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center',flexDirection: 'column'}}>
                {user?.grupos?.length > 0 &&(
                    user?.grupos?.map((gr,index)=>(
                        <Typography key={`${index}TextG`} sx={{color: isDarkMode ? '#e0e0e0' : '#15294b',fontWeight: 'bold'}}>{`Grupo ${index +1}: ${gr?.nombre_g}`}</Typography>
                    ))
                )}
            </Box>
            {/*
            <Divider sx={{background: isDarkMode ? '#3d4a62' : 'gray', my: 1}} />
            
            <Box sx={{ px: 2, mb: 1 }}>
                <Box 
                    sx={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'space-between',
                        cursor: 'pointer',
                        padding: '4px 8px',
                        borderRadius: 2,
                        '&:hover': { background: isDarkMode ? '#2d3a52' : '#f0f0f0' }
                    }}
                    onClick={() => setShowSockets(!showSockets)}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <WifiIcon sx={{ fontSize: 18, color: online ? '#4caf50' : '#f44336' }} />
                        <Typography sx={{ color: isDarkMode ? '#e0e0e0' : '#15294b', fontSize: 13, fontWeight: 'bold' }}>
                            Sockets {online ? '(Conectado)' : '(Desconectado)'}
                        </Typography>
                        <Chip 
                            label={socketEvents.length} 
                            size="small" 
                            sx={{ 
                                height: 20, 
                                fontSize: 11, 
                                background: isDarkMode ? '#3d4a62' : '#e0e0e0',
                                color: isDarkMode ? '#e0e0e0' : '#15294b'
                            }} 
                        />
                    </Box>
                    <IconButton size="small" sx={{ color: isDarkMode ? '#b0bec5' : '#666', p: 0 }}>
                        {showSockets ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
                    </IconButton>
                </Box>
                <Collapse in={showSockets}>                    {currentRoom && (
                        <Box sx={{ mt: 1, px: 1 }}>
                            <Typography sx={{ fontSize: 11, color: isDarkMode ? '#b0bec5' : '#666', mb: 0.5 }}>Sala activa:</Typography>
                            <Chip
                                label={currentRoom}
                                size="small"
                                icon={<WifiIcon sx={{ fontSize: 14 }} />}
                                sx={{
                                    fontSize: 11,
                                    height: 24,
                                    background: isDarkMode ? '#1b5e20' : '#e8f5e9',
                                    color: isDarkMode ? '#81c784' : '#2e7d32',
                                    border: `1px solid ${isDarkMode ? '#2e7d32' : '#a5d6a7'}`,
                                    '& .MuiChip-icon': { color: isDarkMode ? '#81c784' : '#2e7d32' }
                                }}
                            />
                        </Box>
                    )}                    <Box sx={{ 
                        mt: 1, 
                        maxHeight: 200, 
                        overflowY: 'auto', 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: 0.5,
                        p: 1,
                        borderRadius: 2,
                        background: isDarkMode ? '#161f30' : '#fafafa',
                        border: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`
                    }}>
                        {socketEvents.length > 0 ? socketEvents.map((event, i) => (
                            <Chip
                                key={i}
                                label={event}
                                size="small"
                                sx={{
                                    fontSize: 10,
                                    height: 22,
                                    background: isDarkMode ? '#2d3a52' : '#e8eaf6',
                                    color: isDarkMode ? '#90caf9' : '#1a237e',
                                    border: `1px solid ${isDarkMode ? '#3d4a62' : '#c5cae9'}`,
                                }}
                            />
                        )) : (
                            <Typography sx={{ fontSize: 12, color: isDarkMode ? '#b0bec5' : '#999' }}>
                                Sin eventos registrados
                            </Typography>
                        )}
                    </Box>
                </Collapse>
            </Box>*/}

            <Box sx={{display: 'flex', justifyContent:'center',alignItems:'center',mt:2}}>
                <ButtonBasic
                    textButton='Cerrar Sesion'
                    onClick={()=>onLogout()}
                    variant="wk"
                    color='nextWhite'
                    sx={{
                        width: 200,
                        fontWeight: 'bold',
                        border:1,
                        borderColor: isDarkMode ? '#3d4a62' : '#a6aebb',
                        color: isDarkMode ? '#64B5F6' : '#15294b'
                    }}
                    iconStart={<LogoutIcon />}
                />
            </Box>
        </Menu>
        </>
    );
}

export default MenuUsuarioNav